// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1rwVB","itemTitle":"ClientEmergencyInfo_itemTitle__3KiXG","itemText":"ClientEmergencyInfo_itemText__1w-4Y"};